import type { Work } from "@/types";

export const works: Work[] = [
  {
    id: "mv-01",
    title: "深海回响",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["科幻", "悬疑"],
    rating: 8.7,
    duration: "128分钟",
    director: "陈牧之",
    actors: ["林昭", "苏婉清", "周予安"],
    synopsis:
      "一支深海科考队在马里亚纳海沟收到一段无法解释的回声信号，随着下潜深度不断增加，队员们逐渐发现，那段回声并非来自未知生物，而是来自二十年前一同失踪的前辈潜艇。真相与深海压力一同逼近，谁能活着浮出水面？",
    platforms: ["91高清", "极速云", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20artwork%2C%20lone%20diver%20descending%20into%20a%20glowing%20deep%20ocean%20trench%2C%20bioluminescent%20creatures%2C%20dark%20teal%20and%20deep%20blue%20tones%2C%20dramatic%20volumetric%20light%20rays%2C%20mysterious%20atmosphere%2C%20high%20detail%2C%20editorial%20poster%20composition&width=400&height=600&seq=mov-01&orientation=portrait",
    popularity: 9820,
    addedAt: "2024-10-02",
  },
  {
    id: "mv-02",
    title: "无间风暴",
    type: "movie",
    year: 2023,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    rating: 8.3,
    duration: "118分钟",
    director: "麦兆辉",
    actors: ["陈国栋", "郑皓", "梁思敏"],
    synopsis:
      "雨夜，一名卧底警员的身份意外暴露，整个犯罪集团开始内部清洗。在信任崩塌的七十二小时里，他必须在昔日兄弟和冷血对手之间作出抉择，人性的灰色地带被彻底点亮。",
    platforms: ["91高清", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20action%20crime%20thriller%20movie%20poster%20art%2C%20silhouetted%20man%20in%20a%20rain-soaked%20neon%20alley%20at%20night%2C%20cold%20cyan%20and%20amber%20lighting%2C%20tense%20cinematic%20mood%2C%20high%20contrast%2C%20film%20grain%20texture%2C%20dramatic%20poster%20composition&width=400&height=600&seq=mov-02&orientation=portrait",
    popularity: 8710,
    addedAt: "2023-07-18",
  },
  {
    id: "mv-03",
    title: "长安幻夜",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["古装", "奇幻"],
    rating: 8.1,
    duration: "134分钟",
    director: "顾清让",
    actors: ["沈墨白", "叶青禾", "江砚"],
    synopsis:
      "盛唐长安，每到子时便有幻象笼罩坊市。一名年轻的捉妖师奉命彻查怪事，却在中元之夜与亡故多年的挚友重逢。繁华灯火之下，藏着足以倾覆整座城池的古老契约。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20movie%20poster%20art%2C%20lantern-lit%20Tang%20dynasty%20city%20street%20at%20night%2C%20floating%20glowing%20talismans%2C%20warm%20amber%20and%20deep%20indigo%20palette%2C%20misty%20atmosphere%2C%20ornate%20costume%20detail%2C%20painterly%20poster%20composition&width=400&height=600&seq=mov-03&orientation=portrait",
    popularity: 8460,
    addedAt: "2024-08-25",
  },
  {
    id: "mv-04",
    title: "山海行记",
    type: "movie",
    year: 2022,
    region: "中国",
    genres: ["奇幻", "冒险"],
    rating: 7.6,
    duration: "142分钟",
    director: "陆文远",
    actors: ["韩野", "温以宁"],
    synopsis:
      "少年为寻回失踪的父亲，循着一卷上古残图踏入山海秘境。异兽、奇域、古老部族接连现身，而行记的最后一页，写着的竟然是他自己的名字。",
    platforms: ["极速云", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20movie%20poster%20art%2C%20lone%20traveler%20standing%20before%20a%20vast%20ancient%20mountain%20range%20with%20floating%20islands%2C%20mythical%20beasts%20silhouette%2C%20golden%20dawn%20light%20with%20jade%20green%20tones%2C%20sweeping%20epic%20scale%2C%20richly%20detailed%20painting&width=400&height=600&seq=mov-04&orientation=portrait",
    popularity: 6320,
    addedAt: "2022-12-09",
  },
  {
    id: "mv-05",
    title: "城市之光",
    type: "movie",
    year: 2023,
    region: "中国",
    genres: ["剧情"],
    rating: 8.5,
    duration: "112分钟",
    director: "程未",
    actors: ["李泽川", "许静宜"],
    synopsis:
      "一名深夜出租车司机，用后视镜看尽了这座城市的悲欢。当一位多次出现在他车里的女孩突然消失，他决定用一整晚的时间，找回一个素不相识却早已熟悉的人。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20movie%20poster%20art%2C%20rain-glossed%20city%20street%20at%20night%20seen%20through%20a%20taxi%20windshield%2C%20glowing%20street%20lamps%20and%20blurred%20bokeh%20lights%2C%20contemplative%20mood%2C%20amber%20and%20slate%20tones%2C%20cinematic%20depth%2C%20elegant%20poster%20composition&width=400&height=600&seq=mov-05&orientation=portrait",
    popularity: 7180,
    addedAt: "2023-11-03",
  },
  {
    id: "mv-06",
    title: "追风少年",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["青春", "运动"],
    rating: 7.9,
    duration: "106分钟",
    director: "邵川",
    actors: ["方一诺", "陈亦然", "顾小溪"],
    synopsis:
      "小镇少年为了站上全国自行车赛的赛道，用废旧零件拼出一辆车，也拼出了一整个夏天的热望。跌倒、怀疑、并肩，追风的人从不在意起点有多远。",
    platforms: ["91高清"],
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20youth%20sports%20movie%20poster%20art%2C%20teenage%20cyclist%20racing%20along%20a%20sunlit%20coastal%20road%2C%20motion%20blur%20speed%20lines%2C%20fresh%20sky%20blue%20and%20warm%20golden%20tones%2C%20hopeful%20atmosphere%2C%20dynamic%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=mov-06&orientation=portrait",
    popularity: 6890,
    addedAt: "2024-06-14",
  },
  {
    id: "mv-07",
    title: "暗涌",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["悬疑", "犯罪"],
    rating: 8.2,
    duration: "124分钟",
    director: "Ethan Cole",
    actors: ["Marcus Reed", "Nadia Frost"],
    synopsis:
      "一名犯罪心理学教授受邀协助调查连环失踪案，线索却一再指向他多年未见的旧日学生。平静的湖面之下，暗涌早已吞没了所有人。",
    platforms: ["91高清", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%20art%2C%20mirrored%20reflection%20of%20a%20lone%20figure%20on%20a%20dark%20still%20lake%20at%20dusk%2C%20cold%20desaturated%20palette%20with%20a%20single%20warm%20accent%2C%20eerie%20calm%2C%20minimalist%20high%20tension%20composition%2C%20fine%20detail&width=400&height=600&seq=mov-07&orientation=portrait",
    popularity: 7540,
    addedAt: "2023-09-21",
  },
  {
    id: "mv-08",
    title: "末日列车",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["灾难", "科幻"],
    rating: 7.8,
    duration: "130分钟",
    director: "Sophia Vance",
    actors: ["Owen Blake", "Grace Lin"],
    synopsis:
      "大气崩坏后的第七年，人类最后一座城市随一列永不停歇的列车穿行荒原。当列车首次偏离既定轨道，乘客们才发现，目的地从来都不是幸存者的希望。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Post-apocalyptic%20sci-fi%20movie%20poster%20art%2C%20massive%20armored%20train%20crossing%20a%20barren%20ruined%20wasteland%20under%20a%20dust-orange%20sky%2C%20dramatic%20scale%2C%20rust%20and%20ember%20color%20palette%2C%20ominous%20cinematic%20atmosphere%2C%20detailed%20concept%20art&width=400&height=600&seq=mov-08&orientation=portrait",
    popularity: 8120,
    addedAt: "2024-05-30",
  },
  {
    id: "mv-09",
    title: "一笑倾城",
    type: "movie",
    year: 2022,
    region: "中国",
    genres: ["喜剧", "爱情"],
    rating: 7.3,
    duration: "98分钟",
    director: "洪小满",
    actors: ["唐可可", "林一鸣"],
    synopsis:
      "婚礼策划师遇上最挑剔的甲方，一场荒诞的假戏真做让两个人手忙脚乱。笑料背后，是两颗慢慢靠近的心。",
    platforms: ["极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Cheerful%20romantic%20comedy%20movie%20poster%20art%2C%20bright%20pastel%20wedding%20setup%20with%20confetti%20and%20balloons%2C%20playful%20candid%20mood%2C%20warm%20coral%20and%20soft%20cream%20palette%2C%20lighthearted%20atmosphere%2C%20clean%20modern%20poster%20composition&width=400&height=600&seq=mov-09&orientation=portrait",
    popularity: 5980,
    addedAt: "2022-05-12",
  },
  {
    id: "mv-10",
    title: "城南旧梦",
    type: "movie",
    year: 2021,
    region: "中国",
    genres: ["爱情", "文艺"],
    rating: 7.7,
    duration: "116分钟",
    director: "闻莺",
    actors: ["宋知远", "白露"],
    synopsis:
      "一封迟到了三十年的信，把年过中年的两个人的记忆重新拉回城南的老巷。时光从不为谁停留，但总有一些人，一直等在原地。",
    platforms: ["91高清"],
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20romantic%20arthouse%20movie%20poster%20art%2C%20quiet%20old%20southern-town%20alley%20with%20hanging%20laundry%20and%20warm%20afternoon%20light%2C%20faded%20vintage%20sepia%20and%20jade%20tones%2C%20gentle%20melancholic%20mood%2C%20minimal%20refined%20composition%2C%20film%20texture&width=400&height=600&seq=mov-10&orientation=portrait",
    popularity: 5120,
    addedAt: "2021-10-08",
  },
  {
    id: "mv-11",
    title: "铁血防线",
    type: "movie",
    year: 2023,
    region: "欧洲",
    genres: ["战争", "历史"],
    rating: 8.4,
    duration: "146分钟",
    director: "Klaus Berger",
    actors: ["Jan Novák", "Elena Marsh"],
    synopsis:
      "一场决定战局的守城战中，一支被遗忘的工兵连奉命死守最后一道防线。没有援军，没有退路，只有彼此和身后的家园。",
    platforms: ["91高清", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20war%20movie%20poster%20art%2C%20weary%20soldiers%20holding%20a%20ruined%20stone%20wall%20under%20a%20gray%20stormy%20sky%2C%20drifting%20smoke%20and%20cold%20steel%20tones%2C%20somber%20heroic%20mood%2C%20dramatic%20chiaroscuro%20lighting%2C%20highly%20detailed%20cinematic%20composition&width=400&height=600&seq=mov-11&orientation=portrait",
    popularity: 7660,
    addedAt: "2023-03-17",
  },
  {
    id: "mv-12",
    title: "星海归途",
    type: "movie",
    year: 2025,
    region: "美国",
    genres: ["科幻", "剧情"],
    rating: 8.6,
    duration: "138分钟",
    director: "Ava Sterling",
    actors: ["Noah Vance", "Iris Chen"],
    synopsis:
      "深空航行的最后一名宇航员在返航途中收到地球早已停电的信号。为了回家，他必须穿越一片会吞噬时间记忆的星云，赌上所有他还记得的人。",
    platforms: ["91高清", "极速云", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Awe-inspiring%20space%20sci-fi%20movie%20poster%20art%2C%20lone%20astronaut%20floating%20before%20a%20luminous%20violet-teal%20nebula%2C%20distant%20blue%20planet%20glow%2C%20vast%20cosmic%20scale%2C%20cinematic%20atmospheric%20lighting%2C%20ultra%20detailed%2C%20elegant%20poster%20composition&width=400&height=600&seq=mov-12&orientation=portrait",
    popularity: 9340,
    addedAt: "2025-01-20",
  },
  {
    id: "tv-01",
    title: "烽火长歌",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["历史", "战争"],
    rating: 8.8,
    duration: "全46集",
    director: "萧正元",
    actors: ["陆沉", "苏晚棠", "秦守"],
    synopsis:
      "乱世烽烟中，一位出身寒门的将领从边关小卒一路成长为护国统帅。权谋、战场与家国抉择交织成一部荡气回肠的长歌。",
    platforms: ["91高清", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20historical%20Chinese%20epic%20drama%20poster%20art%2C%20armored%20general%20overlooking%20vast%20battle%20plains%20at%20dusk%2C%20war%20banners%20and%20drifting%20embers%2C%20deep%20crimson%20and%20ink%20blue%20palette%2C%20majestic%20cinematic%20mood%2C%20richly%20detailed%20costume%20and%20armor&width=400&height=600&seq=tv-01&orientation=portrait",
    popularity: 9910,
    addedAt: "2024-09-11",
  },
  {
    id: "tv-02",
    title: "都市迷情",
    type: "tv",
    year: 2023,
    region: "中国",
    genres: ["都市", "爱情"],
    rating: 7.9,
    duration: "全40集",
    director: "何嘉树",
    actors: ["乔木", "沈亦双"],
    synopsis:
      "两位在写字楼里相互博弈的职场精英，白天是针锋相对的对手，夜晚却是同一栋楼顶分享心事的陌生人。误会与心动同时生长。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20art%2C%20stylish%20young%20couple%20on%20a%20glass%20skyscraper%20rooftop%20at%20blue%20hour%2C%20glowing%20city%20skyline%20below%2C%20cool%20slate%20and%20warm%20amber%20accents%2C%20sleek%20sophisticated%20mood%2C%20elegant%20editorial%20composition&width=400&height=600&seq=tv-02&orientation=portrait",
    popularity: 8420,
    addedAt: "2023-12-01",
  },
  {
    id: "tv-03",
    title: "锦绣山河",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["古装", "权谋"],
    rating: 8.5,
    duration: "全52集",
    director: "顾清让",
    actors: ["沈墨白", "叶青禾", "温故"],
    synopsis:
      "一纸密诏牵动朝野，聪慧的绣坊女官被卷入皇权更迭的漩涡。她以针线为刃，在锦绣山河的棋局中步步为营。",
    platforms: ["91高清", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Opulent%20ancient%20Chinese%20palace%20intrigue%20drama%20poster%20art%2C%20elegant%20woman%20in%20embroidered%20hanfu%20standing%20in%20a%20lantern-lit%20palace%20hall%2C%20gold%20and%20jade%20palette%2C%20misty%20imperial%20atmosphere%2C%20intricate%20textile%20detail%2C%20graceful%20cinematic%20composition&width=400&height=600&seq=tv-03&orientation=portrait",
    popularity: 8760,
    addedAt: "2024-04-19",
  },
  {
    id: "tv-04",
    title: "破晓行动",
    type: "tv",
    year: 2023,
    region: "中国",
    genres: ["警匪", "悬疑"],
    rating: 8.2,
    duration: "全36集",
    director: "罗晋",
    actors: ["韩烈", "周曼"],
    synopsis:
      "一支精英缉毒小组追查一条跨国贩毒链，线索却一次次被人提前截断。内鬼就藏在身边，破晓之前，没有人可以相信。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20police%20thriller%20TV%20drama%20poster%20art%2C%20detective%20silhouettes%20against%20a%20dawn%20warehouse%20skyline%2C%20red%20and%20blue%20emergency%20light%20accents%2C%20tense%20gritty%20mood%2C%20cold%20steel%20and%20amber%20palette%2C%20high%20contrast%20cinematic%20composition&width=400&height=600&seq=tv-04&orientation=portrait",
    popularity: 8050,
    addedAt: "2023-06-27",
  },
  {
    id: "tv-05",
    title: "医者仁心",
    type: "tv",
    year: 2022,
    region: "中国",
    genres: ["医疗", "剧情"],
    rating: 8.0,
    duration: "全38集",
    director: "温子由",
    actors: ["程亦", "林曦"],
    synopsis:
      "急诊科的一盏长明灯，照见生死之间的距离。年轻医生在一次次抢救中学会与无能为力和解，也更懂得何为仁心。",
    platforms: ["极速云", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20medical%20drama%20TV%20poster%20art%2C%20dedicated%20young%20doctor%20in%20a%20softly%20lit%20hospital%20corridor%20at%20night%2C%20clean%20white%20coat%2C%20calm%20teal%20and%20warm%20palette%2C%20compassionate%20hopeful%20mood%2C%20refined%20cinematic%20composition%2C%20high%20detail&width=400&height=600&seq=tv-05&orientation=portrait",
    popularity: 6980,
    addedAt: "2022-09-05",
  },
  {
    id: "tv-06",
    title: "青云志远",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["武侠", "古装"],
    rating: 8.3,
    duration: "全44集",
    director: "江砚",
    actors: ["江白", "洛青弦", "云舒"],
    synopsis:
      "背负师门血仇的少年踏入江湖，从快意恩仇到勘破执念。剑锋所至，是少年意气，也是一个人与整个时代的和解。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20TV%20drama%20poster%20art%2C%20young%20swordsman%20standing%20on%20a%20misty%20mountain%20cliff%20amid%20drifting%20bamboo%20leaves%2C%20flowing%20robes%2C%20jade%20green%20and%20ink%20tones%2C%20ethereal%20Chinese%20ink-wash%20mood%2C%20dynamic%20elegant%20composition&width=400&height=600&seq=tv-06&orientation=portrait",
    popularity: 8290,
    addedAt: "2024-07-08",
  },
  {
    id: "tv-07",
    title: "完美关系",
    type: "tv",
    year: 2023,
    region: "日韩",
    genres: ["爱情", "都市"],
    rating: 7.6,
    duration: "全24集",
    director: "Kim Ji-hoon",
    actors: ["Han Seo-yeon", "Park Min-jae"],
    synopsis:
      "合约结婚的两个人约定好互不干涉，却在柴米油盐的日常里，一点点拆掉了彼此立下的所有规则。",
    platforms: ["91高清"],
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20poster%20art%2C%20stylish%20couple%20in%20matching%20knitted%20sweaters%20in%20a%20cozy%20sunlit%20apartment%2C%20soft%20pastel%20peach%20and%20cream%20palette%2C%20heartwarming%20intimate%20mood%2C%20clean%20modern%20editorial%20composition%2C%20high%20detail&width=400&height=600&seq=tv-07&orientation=portrait",
    popularity: 7240,
    addedAt: "2023-08-15",
  },
  {
    id: "tv-08",
    title: "罪案追踪",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["悬疑", "犯罪"],
    rating: 8.6,
    duration: "全20集",
    director: "Daniel Cross",
    actors: ["Ethan Ward", "Lena Ortiz"],
    synopsis:
      "行为分析小组每集追缉一个未解悬案，用犯罪心理的拼图还原真相。而贯穿全季的那桩旧案，正一步步逼近探员自己。",
    platforms: ["91高清", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20investigation%20thriller%20TV%20poster%20art%2C%20moody%20detective%20office%20wall%20covered%20with%20tied%20case%20photos%20and%20red%20strings%2C%20single%20desk%20lamp%20glow%2C%20desaturated%20palette%20with%20warm%20accent%2C%20suspenseful%20atmosphere%2C%20detailed%20cinematic%20composition&width=400&height=600&seq=tv-08&orientation=portrait",
    popularity: 8890,
    addedAt: "2024-02-28",
  },
  {
    id: "tv-09",
    title: "少年游侠",
    type: "tv",
    year: 2022,
    region: "中国",
    genres: ["青春", "武侠"],
    rating: 7.4,
    duration: "全30集",
    director: "邵川",
    actors: ["方一诺", "洛青弦"],
    synopsis:
      "四个出身各异的少年在一座江湖小城结伴闯荡，笨拙却认真。少年游侠的故事，从来不是成为大侠，而是不辜负彼此。",
    platforms: ["极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Youthful%20wuxia%20adventure%20TV%20poster%20art%2C%20group%20of%20four%20young%20friends%20laughing%20on%20a%20grassy%20hilltop%20with%20swords%2C%20bright%20summery%20sky%2C%20jade%20green%20and%20warm%20gold%20palette%2C%20lively%20hopeful%20mood%2C%20bright%20cinematic%20composition&width=400&height=600&seq=tv-09&orientation=portrait",
    popularity: 6120,
    addedAt: "2022-06-30",
  },
  {
    id: "tv-10",
    title: "家国天下",
    type: "tv",
    year: 2023,
    region: "中国",
    genres: ["历史", "剧情"],
    rating: 8.4,
    duration: "全48集",
    director: "萧正元",
    actors: ["陆沉", "秦守", "苏晚棠"],
    synopsis:
      "三代人跨越半世纪的沉浮，映照一个国家的巨变。大家与小家、理想与现实，在时代的洪流里一次次碰撞。",
    platforms: ["91高清", "蓝光专线"],
    cover:
      "https://readdy.ai/api/search-image?query=Sprawling%20historical%20family%20saga%20TV%20poster%20art%2C%20multi-generational%20family%20portrait%20in%20front%20of%20a%20grand%20courtyard%20gate%20across%20changing%20eras%2C%20warm%20sepia%20and%20deep%20green%20tones%2C%20sweeping%20nostalgic%20mood%2C%20richly%20detailed%20cinematic%20composition&width=400&height=600&seq=tv-10&orientation=portrait",
    popularity: 7910,
    addedAt: "2023-10-22",
  },
  {
    id: "tv-11",
    title: "暗夜行者",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["谍战", "悬疑"],
    rating: 8.5,
    duration: "全34集",
    director: "罗晋",
    actors: ["韩烈", "周曼", "江砚"],
    synopsis:
      "1940年代的孤岛，一名身兼双重身份的情报员行走于暗夜之中。每一次递出的情报，都可能是自己的死亡通知。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20espionage%20spy%20thriller%20TV%20poster%20art%2C%20trench-coated%20figure%20under%20a%20single%20street%20lamp%20on%20a%20foggy%201940s%20street%2C%20rain-slick%20pavement%2C%20deep%20teal%20and%20amber%20palette%2C%20noir%20suspenseful%20mood%2C%20elegant%20cinematic%20composition&width=400&height=600&seq=tv-11&orientation=portrait",
    popularity: 8540,
    addedAt: "2024-03-14",
  },
  {
    id: "tv-12",
    title: "星海学院",
    type: "tv",
    year: 2025,
    region: "日韩",
    genres: ["科幻", "青春"],
    rating: 7.8,
    duration: "全26集",
    director: "Sato Hiro",
    actors: ["Aoi Nakamura", "Rin Tanaka"],
    synopsis:
      "人类第一所星际学院迎来新一届学员。天赋、友情与一场突如其来的宇宙危机，让这群少年被迫提前长大。",
    platforms: ["91高清", "极速云"],
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20academy%20TV%20poster%20art%2C%20young%20cadets%20in%20sleek%20uniforms%20before%20a%20glowing%20orbital%20academy%20window%20overlooking%20stars%2C%20cyan%20and%20violet%20accent%20lighting%2C%20bright%20adventurous%20mood%2C%20clean%20detailed%20cinematic%20composition&width=400&height=600&seq=tv-12&orientation=portrait",
    popularity: 7480,
    addedAt: "2025-02-06",
  },
];

export const movies = works.filter((item) => item.type === "movie");
export const tvShows = works.filter((item) => item.type === "tv");